import Image from "next/image";
import Card from "@/components/UI/Card/Card";
import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";
import classNames from "classnames";

interface Section15Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const HowItWorksSection = ({ job, page, section, ...props }: Section15Props) => {
  return (
    <Section section={section} {...props}>
      <SectionContainer section={section}>
        <SectionHeader section={section} />
        {section?.FeatureCards?.length > 0 && (
          <div className="flex flex-col gap-10 lg:flex-row">
            {section?.FeatureCards?.map((card: any) => {
              return (
                <Card
                  className="flex flex-1 flex-col items-center gap-4 px-8 py-10 text-center"
                  key={card?.id}
                  rounded="large"
                  shadow="none"
                >
                  {card.Image?.data?.attributes && (
                    <Image
                      alt={card?.Image?.data?.attributes?.alternativeText}
                      src={card?.Image?.data?.attributes?.url}
                      width={card?.Image?.data?.attributes?.width ?? "100"}
                      height={card?.Image?.data?.attributes?.height ?? "100"}
                      priority
                    />
                  )}
                  {card.Icon?.data?.attributes && (
                    <div
                      className={classNames(
                        "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg",
                        card?.IconContainerClassName
                      )}
                      style={card?.IconContainerStyle}
                    >
                      <div
                        className={classNames("h-7 w-7", card?.IconClassName)}
                        style={{
                          mask: `url(${card.Icon?.data?.attributes?.url}) no-repeat center / contain`,
                          WebkitMask: `url(${card?.Icon?.data?.attributes?.url}) no-repeat center / contain`,
                          ...card?.IconStyle,
                        }}
                      />
                    </div>
                  )}
                  <div className="text-lg font-bold">{card?.Title}</div>
                  <div className="text-vpGray-700">{card?.Body}</div>
                </Card>
              );
            })}
          </div>
        )}
      </SectionContainer>
    </Section>
  );
};

export default HowItWorksSection;
